// See http://stackoverflow.com/a/35862620

module.exports = function () {
  const arg = Array.prototype.slice.call(arguments, 0);
  arg.pop();
  return arg.join("");
};
